module.exports = __webpack_public_path__ + "img/emoji_tushe.42583d25.png";